/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Text_HelperInputs */

const en_tts_tool_text_helper = /** @type {(inputs: Tts_Tool_Text_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate a short audio read-along from pasted text.`)
};

const es_tts_tool_text_helper = /** @type {(inputs: Tts_Tool_Text_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera una vista previa con audio a partir del texto pegado.`)
};

/**
* | output |
* | --- |
* | "Generate a short audio read-along from pasted text." |
*
* @param {Tts_Tool_Text_HelperInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_text_helper = /** @type {((inputs?: Tts_Tool_Text_HelperInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Text_HelperInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_text_helper(inputs)
	return en_tts_tool_text_helper(inputs)
});